import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

const SOURCE_LABELS = {
  recording: 'Recording',
  upload:    'Upload',
  url:       'URL',
};

export default function SessionCard({ session, onDelete }) {
  const { session_id, created_at, source_type, metrics, file_id } = session;
  const wpm = metrics?.wpm ?? 0;
  const fillerCount = metrics?.filler_words?.count ?? 0;
  const vocabScore = metrics?.vocabulary?.score ?? null;
  const paceScore = metrics?.pace_consistency?.consistency_score ?? null;

  const primaryScore = vocabScore ?? paceScore ?? null;
  const scoreColor = primaryScore == null ? 'var(--text-muted)'
    : primaryScore >= 70 ? 'var(--color-success)'
    : primaryScore >= 40 ? 'var(--accent)'
    : 'var(--color-danger)';

  return (
    <Link
      to={`/history/${session_id}`}
      className="block rounded-xl p-4 transition-all"
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--accent-dim)',
        textDecoration: 'none',
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--border-accent)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--accent-dim)'; }}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-mono" style={{ color: 'var(--text-faint)' }}>
          {format(new Date(Number(created_at)), 'MMM d, yyyy · h:mm a')}
        </span>
        <div className="flex items-center gap-2">
          {file_id && <span className="text-xs" style={{ color: 'var(--text-faint)' }}>🎙️</span>}
          <span
            className="text-[10px] font-mono font-medium px-2 py-0.5 rounded-full"
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border-subtle)',
              color: 'var(--text-faint)',
            }}
          >
            {SOURCE_LABELS[source_type] ?? 'Upload'}
          </span>
          {onDelete && (
            <button
              type="button"
              aria-label="Delete analysis"
              className="text-xs px-1.5 py-0.5 rounded transition-colors"
              style={{ color: 'var(--text-faint)' }}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDelete(session_id); }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--color-danger)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-faint)'; }}
            >
              🗑
            </button>
          )}
        </div>
      </div>

      <div className="flex gap-5">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.15em] mb-0.5"
               style={{ color: 'var(--text-faint)' }}>
            Pace
          </div>
          <div className="text-lg font-bold font-mono" style={{ color: 'var(--text-primary)' }}>
            {wpm} <span className="text-xs font-normal" style={{ color: 'var(--text-faint)' }}>WPM</span>
          </div>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.15em] mb-0.5"
               style={{ color: 'var(--text-faint)' }}>
            Fillers
          </div>
          <div className="text-lg font-bold font-mono" style={{ color: fillerCount === 0 ? '#4AC57A' : 'var(--text-primary)' }}>
            {fillerCount}
          </div>
        </div>
        {primaryScore != null && (
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.15em] mb-0.5"
                 style={{ color: 'var(--text-faint)' }}>
              {vocabScore != null ? 'Vocab' : 'Pace Score'}
            </div>
            <div className="text-lg font-bold font-mono" style={{ color: scoreColor }}>
              {primaryScore}
            </div>
          </div>
        )}
      </div>
    </Link>
  );
}
